export const recordingObjectPrefix = {
  type: "string",
  minLength: 1,
  maxLength: 1_024
};
